export default {
  security: "בטיחות",
  reset: "אתחול",
  save:"שמור",
  profile: "פרופיל"
}